module.exports = __webpack_public_path__ + "static/media/01D.8f1f3e97.png";